<template>
  <!-- CONTENIDO -->
  <div class="contacto-page bg-light">
    <div class="container py-4">
      <ContactoForm :selectedLang="selectedLang" />

      <hr class="my-4" />

      <FrequentAsk
        :faqs="faqsContent[selectedLang]"
        :faqTitle="faqTitle"
      />
    </div>
  </div>

  <!-- FOOTER FUERA del wrapper para no heredar estilos -->
  <SiteFooter :selectedLang="selectedLang" />
</template>

<script>
import ContactoForm from '@/components/ContactoForm.vue'
import FrequentAsk from '@/components/FrequentAsk.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { useSEO } from '@/composables/useSEO';
import { faqsContent } from '@/assets/data/data.ts'

export default {
  name: 'ContactoPage',
  components: {
    ContactoForm,
    FrequentAsk,
    SiteFooter
  },
  props: {
    selectedLang: { type: String, default: 'es' }
  },
  setup() {
    useSEO({
      title: 'Contacto',
      description: '¿Listo para transformar tu industria? Contáctanos y un experto de Frenkel Engineering te asesorará en automatización, Industria 4.0 y capacitación industrial.',
      path: '/contacto',
    });
  },
  computed: {
    faqTitle () {
      switch (this.selectedLang) {
        case 'en': return 'Frequently Asked Questions'
        case 'de': return 'Häufig gestellte Fragen'
        default:   return 'Preguntas frecuentes'
      }
    }
  },
  data () {
    return { faqsContent }
  }
}
</script>

<style scoped>
.contacto-page {
  min-height: 100vh;
  background: #f6fafb;
  /* Evita que estilos internos afecten al footer */
  padding-bottom: 32px;
  overflow-x: hidden;
}

/* Deja que el container crezca y respire sin empujar el footer */
.container {
  margin-bottom: 0;
}

hr {
  border-color: #e5e7eb;
}

/* Ajuste pequeño en móvil */
@media (max-width: 991.98px) {
  .contacto-page { padding-bottom: 24px; }
}
</style>
